import React, { useEffect, useState } from "react";

import * as yup from 'yup';
import { differenceInYears, isDate, isValid, parseISO } from "date-fns";
import { checkEmailLoginV2, checkPhoneLoginV2, sendAvatarInitial, sendLoginV2, sendRegisterV2, validateSessionV2 } from "../../components/layout/sendForm";
import { useDatalayer } from "../../hooks/useDatalayer";

const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com'];

const validateDate = (date: string) => {
    const parsedDate = parseISO(date);
    return isDate(parsedDate) && isValid(parsedDate);
};

const validateAge = (date: string) => {
    const parsedDate = parseISO(date);
    const age = differenceInYears(new Date(), parsedDate);
    return age >= 18;
};

export const useLoginForm = ({ pp = '' }: { pp: string | null }) => {
    const { pushDatalayer } = useDatalayer('Votaciones');
    const [stepNumber, setStepNumber] = useState<number>(1);
    const [isLoading, setIsLoading] = useState(false);

    //* FORM CONTROL
    const [loginErrors, setLoginErrors] = useState<{ [key: string]: string }>({});
    const [loginValues, setLoginValues] = useState({
        mail: '',
        phone: '',
        firstname: '',
        lastname: '',
        tyc: 0,
        privacity: 0,
        marketing: 0,
        pp,
        pp_res: ''
    });
    const [birthdate, setBirthdate] = useState({
        day: '',
        month: '',
        year: '',
    });

    //* FORM SCHEMA
    const loginSchema = yup.object().shape({
        mail: yup
            .string()
            .required('El email es obligatorio')
            .email('Debe ser un email válido')
            .test(
                'no-mailinator',
                'Ingrese un email válido',
                (value) => {
                    let array_email = value.split("@");
                    return !emails.find(m => m === array_email[1]);
                }
            ),
        phone: yup
            .string()
            .required('El teléfono es obligatorio')
            .matches(/^[0-9]+$/, 'El teléfono solo puede contener números')
            .min(7, 'El teléfono debe tener al menos 7 caracteres')
            .max(10, 'El teléfono debe ser de máximo 10 caracteres'),
        firstname: yup
            .string()
            .required('El nombre es obligatorio')
            .matches(/^[^\d]*$/, 'El nombre no debe contener números'),
        lastname: yup
            .string()
            .required('El nombre es obligatorio')
            .matches(/^[^\d]*$/, 'El nombre no debe contener números'),
        birthdate: yup
            .string()
            .required('La fecha de nacimiento es obligatoria')
            .test('is-valid-date', 'La fecha es inválida', (value) => {
                if (!value) return true;
                return validateDate(value);
            })
            .test('is-adult', 'Debes ser mayor de edad', (value) => {
                if (!value) return true;
                return validateAge(value);
            })
            .required('La fecha de nacimiento es requerida'),
        pp_res: yup
            .string()
            .required('Debes seleccionar una opción')
    });

    //* VALIDATION FORM FIELD
    const validateField = async (id: string, value: string) => {
        if (pp === '' && id === 'pp_res') return { valid: true }

        try {
            await loginSchema.validateAt(id, { [id]: value });
            setLoginErrors((prevState) => ({ ...prevState, [id]: '' }));
            return { valid: true };
        } catch (validationError) {
            setLoginErrors((prevState) => ({ ...prevState, [id]: validationError.message }));
            return { valid: false };
        }
    }

    const handleCheck = ({ target }: { target: HTMLInputElement }) => {
        const { id, checked } = target;
        setLoginValues({ ...loginValues, [id]: checked ? 1 : 0 });
        if (checked) setLoginErrors((prevState) => ({ ...prevState, [id]: '' }));
    }

    const handleChange = async ({ target }: { target: HTMLInputElement | HTMLSelectElement }) => {
        const { id, value } = target;
        setLoginValues({ ...loginValues, [id]: value });
        validateField(id, value);
    }

    const handleBirthdate = ({ target }: { target: HTMLSelectElement }) => {
        const { id, value } = target;
        setBirthdate({ ...birthdate, [id]: value });
    }

    //* SEND LOGIN (STEP 1)
    const loginUser = async () => {
        try {
            const { mail, phone } = loginValues;
            const { valid: validEmail } = await validateField('mail', mail);
            const { valid: validPhone } = await validateField('phone', phone);
            if (!validEmail || !validPhone) return;

            const response = await sendLoginV2({ mail, phone });
            switch (response.message) {
                case 'NO_USER':
                    setStepNumber(2);
                    pushDatalayer({
                        'event_action': 'Button',
                        'event_label': 'Form Step 1',
                        'component_name': 'Estadio_Form',
                        'element_text': 'Elegir Partido',
                    });
                    break;

                case 'MAIL_ERROR':
                case 'LOGIN_ERROR':
                    setLoginErrors((prevState) => ({ ...prevState, phone: 'Ha ocurrido un error en el inicio de sesión' }));
                    break;

                case 'SUCCESS':
                    await validateSessionV2();
                    pushDatalayer({
                        'event_action': 'Log in',
                        'event_label': 'Log in success',
                        'component_name': 'Estadio_log in',
                        'element_text': 'Log In',
                    });
                    if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
                        var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
                        window.location.href = parameterValue
                    }
                    else {
                        location.href = response.data?.redirect || '/';
                    }
                    break;
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    //* VALIDATE REGISTER (STEP 2)
    const validateRegisterForm = async () => {
        try {
            const { mail, phone, firstname, lastname, pp_res } = loginValues;
            const fields: { [key: string]: string } = { mail, phone, firstname, lastname, pp_res };
            let thereIsError = false;

            for (const key in fields) {
                const { valid } = await validateField(key, fields[key]);
                if (!valid) thereIsError = true;
            }

            const { valid: validBirthdate } = await validateField('birthdate', Object.values(birthdate).every(item => item) ? `${birthdate.year}-${birthdate.month}-${birthdate.day}` : '');
            if (thereIsError || !validBirthdate) return;

            await checkEmailLoginV2(loginValues.mail);
            await checkPhoneLoginV2(loginValues.phone);
            setLoginErrors((prevState) => ({ ...prevState, email: '', phone: '' }));

            pushDatalayer({
                'event_action': 'Button',
                'event_label': 'Form step 2',
                'component_name': 'Estadio_Form',
                'element_text': 'Elegir partido',
            });
            setStepNumber(3);
        } catch (err) {
            setLoginErrors((prevState) => ({ ...prevState, [err.field]: err.message }));
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    //* VALIDATE TERMS AND SEND REGISTER (STEP 3)
    const validateTerms = async (preferences: any) => {
        pushDatalayer({
            'event_action': 'Button',
            'event_label': 'Form Step 3',
            'component_name': 'Estadio_Form',
            'element_text': 'Finalizar Registro',
        });

        try {
            const messages = { tyc: '', privacity: '' };
            if (loginValues.tyc === 0) messages.tyc = 'Debes aceptar términos y condiciones';
            if (loginValues.privacity === 0) messages.privacity = 'Debes aceptar políticas de privacidad';
            setLoginErrors((prevState) => ({ ...prevState, ...messages }));

            if (!Object.values(messages).every(item => item === '')) return;

            const birthday = `${birthdate.day}-${birthdate.month}-${birthdate.year}`;
            const register_payload =
                loginValues.marketing === 0
                    ? {
                        ...loginValues,
                        birthday,
                        mark_sms: 0,
                        mark_email: 0,
                        mark_call: 0,
                        mark_app: 0,
                        mark_send: 0
                    }
                    : {
                        ...loginValues, ...preferences, birthday
                    };
            const response = await sendRegisterV2(register_payload);
            if (response.message !== 'SUCCESS') return;
            await validateSessionV2();
            sendAvatarInitial(sessionStorage.getItem('tempGender') || "Hombre");

            pushDatalayer({
                'event_category': 'Register',
                'event_action': 'Success',
                'event_label': 'Register Successful',
                'component_name': 'Estadio_Form',
                'element_text': 'Registro Exitoso',
            });
            if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
                var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
                location.href = parameterValue
            }
            else {
                location.href = response.data?.redirect || '/';
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    const onSubmit = async (preferences?: any) => {
        setIsLoading(true);
        switch (stepNumber) {
            case 1:
                loginUser();
                break;

            case 2:
                validateRegisterForm();
                break;

            case 3:
                validateTerms(preferences);
                break;
        }
    }

    //* VALIDATE BIRTHDATE
    useEffect(() => {
        const validBirthdate = async () => {
            try {
                const date = `${birthdate.year}-${birthdate.month}-${birthdate.day}`
                await loginSchema.validateAt('birthdate', { birthdate: date });
                setLoginErrors((prevState) => ({ ...prevState, birthdate: '' }));
            } catch (validationError) {
                setLoginErrors((prevState) => ({ ...prevState, birthdate: validationError.message }));
            }
        }
        if (Object.values(birthdate).every(value => value)) validBirthdate();
    }, [birthdate]);

    return {
        stepNumber,
        isLoading,
        loginErrors,
        onSubmit,
        login: {
            values: loginValues,
            onChange: handleChange,
            onCheck: handleCheck,
        },
        birthdate: {
            value: birthdate,
            onChange: handleBirthdate,
        }
    }
}